// frontend/src/components/VoiceRecorder/RecordingControls.js
import React from 'react';
import './RecordingControls.css';

const RecordingControls = ({
  isRecording,
  isPaused,
  hasRecording,
  onStart,
  onPause,
  onResume,
  onStop,
  onCancel,
  onSave,
  onReRecord
}) => {
  // Before recording started
  if (!isRecording && !hasRecording) {
    return (
      <div className="recording-controls">
        <button 
          type="button"
          className="control-btn record-btn"
          onClick={onStart}
          aria-label="Start recording"
        >
          <span className="btn-icon">🎤</span>
          <span className="btn-text">Start Recording</span>
        </button>
        
        <button 
          type="button"
          className="control-btn cancel-btn"
          onClick={onCancel}
          aria-label="Cancel"
        >
          <span className="btn-icon">❌</span>
          <span className="btn-text">Cancel</span>
        </button>
      </div>
    );
  }

  // During recording
  if (isRecording && !hasRecording) {
    return (
      <div className="recording-controls recording-active">
        {isPaused ? (
          <button 
            type="button"
            className="control-btn resume-btn"
            onClick={onResume}
            aria-label="Resume recording"
          >
            <span className="btn-icon">▶️</span>
            <span className="btn-text">Resume</span>
          </button>
        ) : (
          <button 
            type="button"
            className="control-btn pause-btn"
            onClick={onPause}
            aria-label="Pause recording"
          >
            <span className="btn-icon">⏸️</span>
            <span className="btn-text">Pause</span>
          </button>
        )}
        
        <button 
          type="button"
          className="control-btn stop-btn"
          onClick={onStop}
          aria-label="Stop recording"
        >
          <span className="btn-icon">⏹️</span>
          <span className="btn-text">Stop</span>
        </button>
        
        <button 
          type="button"
          className="control-btn cancel-btn"
          onClick={onCancel}
          aria-label="Cancel recording"
        >
          <span className="btn-icon">❌</span>
          <span className="btn-text">Cancel</span>
        </button>
      </div>
    );
  }

  // After recording (preview mode) - CRITICAL FIX HERE
  if (hasRecording) {
    return (
      <div className="recording-controls preview-mode">
        <button 
          type="button"
          className="control-btn re-record-btn"
          onClick={onReRecord}
          aria-label="Re-record"
        >
          <span className="btn-icon">🔄</span>
          <span className="btn-text">Re-record</span>
        </button>
        
        <button 
          type="button"
          className="control-btn cancel-btn"
          onClick={onCancel}
          aria-label="Cancel"
        >
          <span className="btn-icon">❌</span>
          <span className="btn-text">Cancel</span>
        </button>
        
        <button 
          type="button"
          className="control-btn save-btn primary"
          onClick={onSave}
          aria-label="Save recording"
        >
          <span className="btn-icon">✅</span>
          <span className="btn-text">Save Voice Note</span>
        </button>
      </div>
    );
  }

  return null;
};

export default RecordingControls;